import { BeneficiaryPayload } from '../containers/app/documentCapture/addBankDetails/AddBankDetails.types';

/* eslint-disable import/prefer-default-export */
const getErrorType = (err: Error) => err.constructor.name;

const errorMatching: {[errorType: string]: {[errorMessage: string]: string}} = {
  TypeError: {
    'Failed to fetch': 'warning',
  },
};

export const getLevel = (error: Error) => {
  const errorType = getErrorType(error);
  const errorMatchingList = errorMatching[errorType];
  return errorMatchingList?.[error.message] || 'error';
};

export const captureException = (
  err: Error,
  options: Record<string, Record<string, string>>,
  payload?: BeneficiaryPayload,
) => {
  window?.Sentry?.captureException(
    err,
    {
      extra: { payload },
      level: getLevel(err),
      options,
    },
  );
};
